(function(){
  var KEY='sp_cookie_consent_v1';
  var defaults={necessary:true,analytics:false,marketing:false,ts:null};
  function read(){
    try{
      var raw=localStorage.getItem(KEY);
      return raw?JSON.parse(raw):null;
    }catch(e){return null;}
  }
  function write(value){
    var stored={necessary:true,analytics:!!value.analytics,marketing:!!value.marketing,ts:new Date().toISOString()};
    try{localStorage.setItem(KEY,JSON.stringify(stored));}catch(e){}
    window.SPCookieConsentState=stored;
    window.dispatchEvent(new CustomEvent('sp:cookie-consent',{detail:stored}));
    return stored;
  }
  function removeKnownOptionalCookies(){
    if(!location.hostname)return;
    var names=['_ga','_gid','_gat','_gcl_au','_fbp','_fbc'];
    var host=location.hostname;
    var domains=[host,'.'+host.replace(/^www\./,'')];
    names.forEach(function(name){
      document.cookie=name+'=; Max-Age=0; path=/; SameSite=Lax';
      domains.forEach(function(domain){
        document.cookie=name+'=; Max-Age=0; path=/; domain='+domain+'; SameSite=Lax';
      });
    });
  }
  function el(tag,attrs,html){
    var node=document.createElement(tag);
    Object.keys(attrs||{}).forEach(function(key){
      if(key==='class')node.className=attrs[key];
      else if(key==='hidden')node.hidden=!!attrs[key];
      else node.setAttribute(key,attrs[key]);
    });
    if(html!==undefined)node.innerHTML=html;
    return node;
  }
  function build(){
    var banner=el('section',{class:'sp-cookie-banner',role:'dialog','aria-live':'polite','aria-label':'Obaveštenje o kolačićima',hidden:true});
    banner.innerHTML='<h2>Kolačići</h2><p>Koristimo neophodne kolačiće za rad sajta, korpu i bezbednu kupovinu. Analitičke i marketinške kolačiće koristimo samo ako date pristanak.</p>';
    var actions=el('div',{class:'sp-cookie-actions'});
    var reject=el('button',{class:'sp-cookie-btn',type:'button'},'Odbij neobavezne');
    var settings=el('button',{class:'sp-cookie-btn',type:'button'},'Podesi');
    var accept=el('button',{class:'sp-cookie-btn sp-cookie-btn--primary',type:'button'},'Prihvati sve');
    actions.appendChild(reject);actions.appendChild(settings);actions.appendChild(accept);banner.appendChild(actions);

    var panel=el('section',{class:'sp-cookie-panel',role:'dialog','aria-modal':'true','aria-label':'Podešavanje kolačića',hidden:true});
    panel.innerHTML='<div class="sp-cookie-dialog"><h2>Podešavanje kolačića</h2><p>Neophodni kolačići su uvek uključeni jer omogućavaju osnovne funkcije sajta, korpu, checkout i sigurnost. Ostale kategorije možete uključiti ili isključiti.</p><div class="sp-cookie-option"><div><strong>Neophodni kolačići</strong><p>Rad sajta, sesija, korpa, checkout, sigurnost i čuvanje vašeg izbora kolačića.</p></div><label class="sp-cookie-switch"><input type="checkbox" checked disabled><span class="sp-cookie-slider"></span></label></div><div class="sp-cookie-option"><div><strong>Analitika</strong><p>Pomaže nam da razumemo posećenost i korišćenje sajta bez direktne prodaje podataka.</p></div><label class="sp-cookie-switch"><input type="checkbox" data-cookie-analytics><span class="sp-cookie-slider"></span></label></div><div class="sp-cookie-option"><div><strong>Marketing</strong><p>Koristi se za personalizovane kampanje, remarketing i merenje oglašavanja, ako su takvi alati povezani.</p></div><label class="sp-cookie-switch"><input type="checkbox" data-cookie-marketing><span class="sp-cookie-slider"></span></label></div><div class="sp-cookie-actions"><button class="sp-cookie-btn" type="button" data-cookie-close>Otkaži</button><button class="sp-cookie-btn" type="button" data-cookie-save>Sačuvaj izbor</button><button class="sp-cookie-btn sp-cookie-btn--primary" type="button" data-cookie-accept-panel>Prihvati sve</button></div></div>';
    var footerLink=el('button',{class:'sp-cookie-footer-link',type:'button'},'Podešavanje kolačića');
    document.body.appendChild(banner);document.body.appendChild(panel);

    var footer=document.querySelector('footer');
    if(footer){
      footer.appendChild(footerLink);
    }else{
      footerLink.classList.add('sp-cookie-footer-link--fallback');
      document.body.appendChild(footerLink);
    }

    var analytics=panel.querySelector('[data-cookie-analytics]');
    var marketing=panel.querySelector('[data-cookie-marketing]');
    function openPanel(){
      var current=read()||defaults;
      analytics.checked=!!current.analytics;
      marketing.checked=!!current.marketing;
      panel.hidden=false;
    }
    function closePanel(){panel.hidden=true;}
    function finish(value){
      var stored=write(value);
      if(!stored.analytics&&!stored.marketing)removeKnownOptionalCookies();
      banner.hidden=true;panel.hidden=true;
      footerLink.hidden=false;
    }
    reject.addEventListener('click',function(){finish({analytics:false,marketing:false});});
    accept.addEventListener('click',function(){finish({analytics:true,marketing:true});});
    settings.addEventListener('click',openPanel);
    footerLink.addEventListener('click',openPanel);
    panel.querySelector('[data-cookie-close]').addEventListener('click',closePanel);
    panel.querySelector('[data-cookie-save]').addEventListener('click',function(){finish({analytics:analytics.checked,marketing:marketing.checked});});
    panel.querySelector('[data-cookie-accept-panel]').addEventListener('click',function(){finish({analytics:true,marketing:true});});
    window.SPCookieConsent={open:openPanel,get:read,set:finish};
    var current=read();
    if(current){
      window.SPCookieConsentState=current;
      footerLink.hidden=false;
      window.dispatchEvent(new CustomEvent('sp:cookie-consent',{detail:current}));
    }else{
      footerLink.hidden=true;
      banner.hidden=false;
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build);
  else build();
})();
